<template>
  <b-overlay
    :show="show"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p id="cancel-label">
          กรุณารอสักครู่...
        </p>
      </div>
    </template>
    <div class="card">
      <div class="card-body">
        <div>
          <h2 class="text-dark font-medium-3">
            <i class="fa fa-search" /> ค้นหา
          </h2>
        </div>
        <div class="row">
          <!-- <div class="col-md-2">
            <div class="form-group">
              <label for="username">Keyword</label>
              <input
                id="username"
                v-model="search_val"
                type="text"
                class="form-control"
                placeholder="ยูสเซอร์เนม"
                @keyup.enter="getDeposit()"
              >
            </div>
          </div> -->
          <div class="col-md-2">
            <div class="form-group">
              <label for="username">สถานะ</label>
              <b-form-select
                v-model="search_status"
                :options="statusOPs"
              />
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="dateStart">วันที่เริ่มต้น</label>
              <flat-pickr
                v-model="dateStart"
                class="form-control"
                placeholder="เลือกเวลาเริ่มต้น"
                :config="{ enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: true }"
              />
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="dateEnd">วันที่สิ้นสุด</label>
              <flat-pickr
                v-model="dateEnd"
                class="form-control"
                placeholder="เลือกเวลาสิ้นสุด"
                :config="{ enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: true }"
              />
            </div>
          </div>
          <div class="col-md-1 mt-2">
            <button
              class="btn btn-gradient-dark"
              @click="getDeposit()"
            >
              <feather-icon icon="SearchIcon" />
              ค้นหา
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-card
      no-body
    >
      <b-card-body />
      <b-table
        small
        striped
        hover
        responsive
        show-empty
        class="position-relative items-center"
        :per-page="perPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
        @sort-changed="getDeposit"
      >
        <template #cell(index)="data">
          {{ perPage * (currentPage - 1) + (data.index + 1) }}
        </template>
        <!-- ✅ ปุ่มลูกตา -->
        <template #cell(actions)="{ item }">
          <b-button
            size="sm"
            variant="outline-primary"
            class="d-flex align-items-center justify-content-center"
            @click="onClickDetail(item)"
          >
            <feather-icon icon="EyeIcon" />
          </b-button>
        </template>

        <template #empty="scope">
          <div class="p-2 text-center">
            <img
              src="/box.png"
              alt="empty"
              height="40px"
            > {{ scope.emptyFiltered ? 'No matching records found' : 'ไม่พบข้อมูล' }}
          </div>
        </template>
        <template #cell(picture)="data">
          <b-avatar
            size="lg"
            :src="data.item.picture"
          />
        </template>
        <template #cell(fullname)="{ item }">
          {{ [item.firstNameTh, item.lastNameTh].filter(Boolean).join(' ') || '-' }}
        </template>
      </b-table>
      <!-- ✅ Detail Section -->
      <div
        v-if="showDetailSection && selectedRow"
        class="p-2 mt-2"
      >
        <h5 class="mb-2">
          Detail : {{ selectedRow.ref }} ({{ selectedRow.username }})
        </h5>

        <!-- ตารางย่อย matchedLog -->
        <b-table
          small
          bordered
          responsive
          :items="selectedMatchedLogs"
          :fields="detailFields"
          show-empty
        >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>

          <!-- แสดง status แบบ tag สีเขียว/ฟ้า/แดง -->
          <template #cell(status)="data">
            <span
              class="badge"
              :class="{
                'badge-success': data.item.status === 'SUCCESS',
                'badge-danger': data.item.status === 'TIMEOUT' || data.item.status === 'FAILED',
                'badge-info': data.item.status !== 'SUCCESS' && data.item.status !== 'FAILED' && data.item.status !== 'TIMEOUT',
              }"
            >
              {{ data.item.status }}
            </span>
          </template>
        </b-table>

        <!-- ข้อมูล User ด้านล่าง -->
        <div class="mt-3">
          <h6 class="mb-2">
            User Withdraw Data
          </h6>
          <div class="row">
            <div class="col-md-4 col-12 mb-1">
              <strong>Bank Name :</strong> {{ selectedRow.bankName || '-' }}
            </div>
            <div class="col-md-4 col-12 mb-1">
              <strong>Bank Account :</strong> {{ selectedRow.accountNumber || '-' }}
            </div>
            <div class="col-md-4 col-12 mb-1">
              <strong>Promptpay :</strong> {{ selectedRow.promptPayID || '-' }}
            </div>

            <div class="col-md-4 col-12 mb-1">
              <strong>Firstname (TH) :</strong> {{ selectedRow.firstNameTh || '-' }}
            </div>
            <div class="col-md-4 col-12 mb-1">
              <strong>Lastname (TH) :</strong> {{ selectedRow.lastNameTh || '-' }}
            </div>
            <div class="col-md-4 col-12 mb-1">
              <strong>Created By :</strong> {{ selectedRow.createdBy || '-' }}
            </div>
          </div>
        </div>
      </div>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">

        <!-- page length -->
        <b-form-group
          label="Per Page"
          label-cols="8"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
            @change="getDeposit()"
          />
        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
            @input="getDeposit()"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>

import moment from 'moment-timezone'
import {
  BOverlay, BIconController, BCard, BTable, BAvatar, BFormGroup, BFormSelect, BPagination, BCardBody, VBToggle,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    flatPickr,
    BCard,
    BTable,
    BAvatar,
    BFormGroup,
    BFormSelect,
    BPagination,

    BCardBody,
    BOverlay,
    BIconController,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      status: '',
      ref: '',
      search_type: null,
      search_val: null,
      show: true,
      depositdata: [],
      member: '',
      amount: '',
      optionsMember: '',
      perPage: 20,
      pageOptions: [10, 15, 20, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      usersList: [],
      datasidebar: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        { key: 'index', label: 'no.' },

        { key: 'username', label: 'ยูสเซอร์เนม' },

        {
          key: 'fullname',
          label: 'ชื่อลูกค้า',
          formatter: (val, item) => `${item.firstNameTh || ''} ${item.lastNameTh || ''}`,
        },

        { key: 'accountNumber', label: 'เลขที่บัญชี / พร้อมเพย์' },
        { key: 'bankName', label: 'ธนาคาร' },

        {
          key: 'amount',
          label: 'จำนวนเงิน',
          sortable: true,
          formatter: val => Number(val).toLocaleString(),
        },

        { key: 'status', label: 'สถานะ' },
        { key: 'ref', label: 'เลขอ้างอิง (Ref)' },

        {
          key: 'createdDate',
          label: 'วันที่ทำรายการ',
          formatter: value => moment(value)
            .tz('Asia/Bangkok')
            .format('DD/MM/YYYY HH:mm:ss'),
        },
        { key: 'actions', label: ' ', class: 'text-center' },
      ],
      statusOPs: [
        { value: '', text: 'ทั้งหมด' },
        { value: 'PENDING', text: 'รอดำเนินการ' },
        { value: 'SUCCESS', text: 'สำเร็จ' },
        { value: 'rejected', text: 'ยกเลิก' },
        { value: 'TIMEOUT', text: 'หมดเวลา' },
      ],
      /* eslint-disable global-require */
      items: [],
      addNewDataSidebar: false,
      UserData: JSON.parse(localStorage.getItem('userData')),
      show2: false,
      tel: null,
      search: false,
      dateStart: moment().tz('Asia/Bangkok').format('YYYY-MM-DD 00:00:00'),
      dateEnd: moment().tz('Asia/Bangkok').format('YYYY-MM-DD 23:59:59'),
      search_status: null,
      search_from: null,
      search_admin: null,
      // ✅ เพิ่มใหม่
      selectedRow: null, // แถวที่กำลังกดดู
      selectedMatchedLogs: [], // matchedLog ของแถวนั้น
      showDetailSection: false, // toggle แสดง/ซ่อน detail

      // ✅ fields ของตาราง detail ด้านล่าง
      detailFields: [
        { key: 'index', label: 'No' },
        { key: 'ref', label: 'Transaction Ref' },
        {
          key: 'amount',
          label: 'Amount',
          formatter: val => Number(val).toFixed(2),
        },
        { key: 'status', label: 'Status' },
        {
          key: 'createdDate',
          label: 'Create Date',
          formatter: value => moment(value)
            .tz('Asia/Bangkok')
            .format('DD/MM/YYYY HH:mm:ss'),
        },
        {
          key: 'timeOutDate',
          label: 'Timeout / Success',
          formatter: value => (value && value !== '-'
            ? moment(value).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss')
            : '-'),
        },
      ],
    }
  },
  computed: {
    fullname() {
      return item => `${item.firstNameTh || ''} ${item.lastNameTh || ''}`
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  created() {
    this.interval = setInterval(() => {
      if (this.status_interval) {
        this.getDeposit()
      }
    }, 60000)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  mounted() {
    this.totalRows = this.items.length
    this.getDeposit()
  },
  methods: {
    getDeposit() {
      this.items = []
      this.show = true

      // New API endpoint for AutoPeer deposits
      const URL = '/autopeer/deposit'

      // Map local states to API params
      const params = {
        page: this.currentPage,
        perPage: this.perPage,
        // backend expects ISO or Y-m-d H:i:s; we pass as-is and server will tz-normalize
        startDate: this.dateStart,
        endDate: this.dateEnd,
        // optional filters (server may ignore if unsupported)
        status: this.search_status || '',
        ref: this.ref || '',
        search_val: this.search_val,
      }

      this.$http
        .get(URL, { params })
        .then(({ data: res }) => {
          this.show = false
          // Expected: { perPage, total, data: [...] }
          const list = Array.isArray(res.data) ? res.data : []

          // Keep compatibility with existing table fields
          this.depositdata = list
          this.onFiltered({ data: list, total: Number(res.total || list.length) })
        })
        .catch(error => {
          this.show = false
          console.error(error)
          this.SwalError('ไม่สามารถโหลดรายการฝากได้')
        })
    },
    onClickDetail(item) {
    // ถ้ากดซ้ำ row เดิม: toggle ปิด/เปิด ได้
      if (this.selectedRow && this.selectedRow.id === item.id && this.showDetailSection) {
        this.showDetailSection = false
        return
      }

      this.selectedRow = item
      this.selectedMatchedLogs = Array.isArray(item.matchedLog) ? item.matchedLog : []
      this.showDetailSection = true
    },
    Commas(x) {
      if (!x) {
        return 0
      } if (x % 1 !== 0) {
        return Number(x).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    submit() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          if (this.time && this.time2) {
            this.show = true
            const formData = {
              username: this.member.username,
              uid: this.member.id,
              amount: this.amount,
              dateslip: this.dateslip,
              time: `${this.time}:${this.time2}`,
              bank: this.from,
              currency: this.currency,
              bankdep: this.bankdep,
            }
            this.$http
              .post('/deposit/store', formData)
              .then(() => {
                this.show = false
                this.getDeposit()
                this.time = null
                this.time2 = null
                this.member = ''
                this.amount = ''
                this.from = null
                this.bankdep = null
                this.Success('เติมเครดิต สำเร็จ')
              })
              .catch(error => {
                this.show = false
                this.time = null
                this.time2 = null
                this.member = ''
                this.amount = ''
                this.from = null
                this.SwalError(error.response.data.message)
              })
          } else {
            this.show = false
            this.SwalError('กรุณาใส่ให้ครบทุกช่อง')
          }
        } else {
          this.show = false
          this.SwalError('กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง')
        }
      })
    },
    async checkExportPassword() {
      const obj = {
        password: this.exportPassword,
      }
      this.$http
        .post('/export/checkpass', obj)
        .then(response => {
          if (response.data.status === true) {
            this.exportData()
          } else {
            this.$swal({
              icon: 'error',
              title: '<h3 style="color: #141414">เกิดข้อผิดพลาด!</h3>',
              text: 'รหัสผ่านไม่ถูกต้อง',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
            })
          }
        })
        .catch(error => console.log(error))
    },
    async exportData() {
      try {
        const { data } = await this.$http.get('/export/deposits/byamin', {
          responseType: 'blob',
          params: {
            page: this.currentPage,
            perPage: this.perPage,
            search_type: this.search_type,
            search_val: this.search_val,
            search_from: this.search_from,
            search_admin: this.search_admin,
            dateStart: this.dateStart,
            dateEnd: this.dateEnd,
            currency: this.currency,
          },
        })

        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(
          new Blob([data]),
        )
        // link.setAttribute(`download', 'Export Deposit Date ${this.dateStart} - ${this.dateEnd}.xlsx`)
        link.setAttribute('download', 'รายการฝากโดยแอดมิน.xlsx')
        document.body.appendChild(link)
        link.click()
      } catch (error) {
        console.log(error)
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.items = filteredItems.data
      this.totalRows = filteredItems.total
      // this.currentPage = 1
    },
    Get_userlist() {
      this.$http
        .get('/api/user/list')
        .then(response => {
          this.onFiltered(response.data.message)
        })
        .catch(error => console.log(error))
    },
    addData() {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.toggleDataSidebar(true)
      this.datasidebar = {}
      this.tel = null
      this.search = false
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.toggleDataSidebar(true)
      this.datasidebar = data
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val
    },
    Success(mes) {
      this.$swal({
        icon: 'success',
        title: '<h3 style="color: #141414">ทำรายการสำเร็จ</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    SwalError(mes) {
      this.$swal({
        icon: 'error',
        title: '<h3 style="color: #141414">เกิดข้อผิดพลาด!</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
    },
  },
}
</script>

<style scoped>
table {
  width: 100%;
  color: #fff !important;
}
thead, th, tr {
  color: #fff default;
}
.bank-icon {
    width: 35px;
    height: 35px;
    padding: 5px;
    border-radius: 50%;
  }
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";

.form-item-section {
background-color:$product-details-bg;
}
th {
    color: #fff default;
    background-color: #000 !important;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
